import { IJsonQuery } from '@cian/api-models/common/json_query';
import { getPrettyNumber } from './getPrettyNumber';
import { getPriceLocale } from './getPriceLocale';

/**
 * Формирует строку для цены.
 */
export function getPriceText(jsonQuery: IJsonQuery): string {
  const nbsp = '\u00A0';
  const { price } = jsonQuery;

  if (price === undefined) {
    return '';
  }

  const { value: { gte, lte } } = price;

  switch (true) {
    case (gte !== undefined && lte !== undefined):
      // tslint:disable-next-line:no-non-null-assertion
      return `от ${getPrettyNumber(gte!, '', nbsp)}${nbsp}${getPriceLocale(jsonQuery)}` +
      // tslint:disable-next-line:no-non-null-assertion
             ` до ${getPrettyNumber(lte!, '', nbsp)}${nbsp}${getPriceLocale(jsonQuery)}`;
    case (gte !== undefined):
      // tslint:disable-next-line:no-non-null-assertion
      return `от ${getPrettyNumber(gte!, '', nbsp)}${nbsp}${getPriceLocale(jsonQuery)}`;
    case (lte !== undefined):
      // tslint:disable-next-line:no-non-null-assertion
      return `не дороже ${getPrettyNumber(lte!, '', nbsp)}${nbsp}${getPriceLocale(jsonQuery)}`;
    default:
      return '';
  }
}
